import React from "react";
import { Link } from "react-router-dom";

import styles from "./Auth.organisms.Content.Login.module.scss";
import RoundedButton from "../../../../../components/Auth/atoms/buttons/RoundedButton";
import ModalButton from "../../../../../components/Auth/atoms/modals/ModalButton";
import CostumInput from "../../../../../components/Auth/atoms/forms/InputCostum";
import PasswordInput from "../../../../../components/Auth/atoms/forms/InputPasswordAuth";

import CostumCheckbox from "../../../../../components/Auth/atoms/forms/CheckboxCostum";
import Logo from "../../../../../components/Auth/atoms/images/Logo";
import { capitalize } from "helpers/utils/utils_general";
import i18n from "i18n";

export class Login extends React.Component {
  render() {
    const {
      handleChange,
      handleBlur,
      rememberUser,
      rememberUserChange,
      handleSubmit,
      buttonState = "disabled",
      errors,
      errorMessage
    } = this.props;

    return (
      <div className={styles["sign-in"]}>
        <form onSubmit={handleSubmit}>
          <Logo></Logo>
          <p className={styles["title"]}>{i18n.t("sign.in.account")}</p>
          <div className={styles["form-container"]}>
            <div className={styles["inputs-wrapper"]}>
              <CostumInput
                id={"email"}
                placeholder={capitalize(i18n.t("email"))}
                icon="icon-mail"
                handleChange={handleChange}
                handleBlur={handleBlur}
                error={errorMessage ? " " : errors.email}
              ></CostumInput>
              <PasswordInput
                handleChange={handleChange}
                id={"password"}
                error={errorMessage ? errorMessage : errors.password}
              ></PasswordInput>
            </div>
            <div className={styles["remember-row"]}>
              <CostumCheckbox
                label={i18n.t("remember.me")}
                checked={rememberUser}
                handleChange={rememberUserChange}
              ></CostumCheckbox>
              <Link to="/forgotten" className={styles["link"]}>
                <button data-automation-id="forgot password" type="button">
                  {i18n.t("forgot.password")}
                </button>
              </Link>
            </div>
          </div>
          <div className={styles["rounded-button-wrapper"]}>
            <RoundedButton
              id="button-login"
              legend={capitalize(i18n.t("enter").toLowerCase())}
              handleClick={handleSubmit}
              state={buttonState}
            ></RoundedButton>
          </div>
        </form>
      </div>
    );
  }
}

Login.propTypes = {};

export default Login;
